/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_TitleInputs */

const en_pc_dl_faq_title = /** @type {(inputs: Pc_Dl_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft install questions`)
};

const zh_pc_dl_faq_title = /** @type {(inputs: Pc_Dl_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 安装常见问题`)
};

/**
* | output |
* | --- |
* | "PdfCraft install questions" |
*
* @param {Pc_Dl_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_title = /** @type {((inputs?: Pc_Dl_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_title(inputs)
	return zh_pc_dl_faq_title(inputs)
});
export { pc_dl_faq_title as "pc.dl.faq_title" }